import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for DynamicFilterStore, for use in the registry */ export const DynamicFilterStoreActionTypes = [
    ActionType.CreateDynamicFilter,
    ActionType.UpdateDynamicFilter,
    ActionType.DeleteDynamicFilter,
    ActionType.HydrateDynamicFilters
];
